import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/icons/actions/ico-btn-nova.svg';
import _imports_1 from '@/assets/icons/actions/icon_preview_border.svg';
import _imports_2 from '@/assets/icons/actions/ico-ico-upravitzarizeni.svg';
import _imports_3 from '@/assets/icons/actions/ico-ico-delete.svg';
const _hoisted_1 = { class: "list-page" };
const _hoisted_2 = { class: "layout__content__header d-flex flex-column list-page__header layout__content__header--white" };
const _hoisted_3 = { class: "d-flex flex-wrap mb-4 mb-sm-0 justify-content-between" };
const _hoisted_4 = { class: "mb-1 mb-sm-4" };
const _hoisted_5 = {
    key: 0,
    class: "layout__content__content pt-4 pt-md-5"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
    key: 1,
    class: "layout__content__content pt-4 pt-md-5"
};
const _hoisted_12 = {
    key: 2,
    class: "layout__content__content pt-4 pt-md-5"
};
import { client } from "@/main";
import { onMounted, ref } from "vue";
import PaginatedFetcher from "@/helpers/paginatedFetcher";
import TableV2 from "@/components/custom-table/TableV2.vue";
import HwDeviceFormModal from "@/components/hw-catalogue/hwDeviceFormModal.vue";
import DeleteModal from "@/components/confirmations/delete.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import Loader from "@/components/loader.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'hwCatalogue',
    setup(__props) {
        const store = useStore();
        const { t: $t } = useI18n();
        onMounted(() => {
            loadItems();
            loadTransformationFunctions();
        });
        const items = ref([]);
        const openedItem = ref(null);
        const isFormModalOpen = ref(false);
        const isFormModalReadOnly = ref(true);
        async function loadItems() {
            const fetcher = await client.path("/hwdevices").method("get").create();
            items.value = await new PaginatedFetcher(fetcher).fetchAll();
        }
        const transformationFunctions = ref([]);
        const isTFLoading = ref(false);
        async function loadTransformationFunctions() {
            isTFLoading.value = true;
            const fetcher = new PaginatedFetcher(client.path("/transformations").method("get").create());
            const res = await fetcher.fetchAll();
            transformationFunctions.value = res.filter((tf) => tf.type === "PAYLOAD");
            isTFLoading.value = false;
        }
        function showDetail(item) {
            openedItem.value = item;
            isFormModalOpen.value = true;
            isFormModalReadOnly.value = true;
        }
        function edit(item) {
            openedItem.value = item;
            isFormModalOpen.value = true;
            isFormModalReadOnly.value = false;
        }
        function handleCreate() {
            openedItem.value = {
                manufacturer: "",
                model: "",
                revision: "",
                technology: "LORA",
                transformationId: null,
                port: 0
            };
            isFormModalOpen.value = true;
            isFormModalReadOnly.value = false;
        }
        const isDeleteOpen = ref(false);
        function handleDelete(item) {
            openedItem.value = item;
            isDeleteOpen.value = true;
        }
        async function handleDeleteConfirmed() {
            store.commit("modals/setWaitingLoader", $t("DELETING"));
            try {
                await client.path("/hwdevices/{hwDeviceId}").method("delete").create()({ hwDeviceId: openedItem.value.hwDeviceId.toString() });
                const notification = [
                    {
                        text: "HW_DEVICE_DELETED",
                        error: false,
                        params: {
                            hwDeviceModel: openedItem.value.model
                        }
                    }
                ];
                store.commit("modals/setGlobalNotification", notification);
                loadItems();
            }
            catch (e) {
                console.error(e);
                store.commit("modals/setError", e.data.errors);
            }
            store.commit("modals/setWaitingLoader", "");
            isDeleteOpen.value = false;
        }
        const columns = [
            { name: "manufacturer", title: "MANUFACTURER", sortable: true, visible: true, minWidth: "150px" },
            { name: "model", title: "MODEL", sortable: true, visible: true, minWidth: "180px" },
            { name: "revision", title: "REVISION", sortable: true, visible: true, minWidth: "120px" },
            { name: "technology", title: "TECHNOLOGY", sortable: true, visible: true, minWidth: "150px" },
            { name: "transformationId", title: "TRANSFORMATION_FUNCTION", sortable: true, visible: true, minWidth: "220px" }
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref($t)("HW_CATALOGUE_HEADER")), 1),
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "list-page__buttons d-none d-sm-flex align-items-center justify-content-between" }, null, -1)),
                            _createElementVNode("button", {
                                class: "btn btn-primary d-flex align-items-center justify-content-center",
                                onClick: handleCreate
                            }, [
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "atom-icon" }, [
                                    _createElementVNode("img", { src: _imports_0 })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_unref($t)("NEW_HW_DEVICE")), 1)
                            ])
                        ])
                    ]),
                    (items.value.length && !isTFLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(TableV2, {
                                columns: columns,
                                items: items.value,
                                "items-total-count": items.value.length,
                                "item-id": "hwDeviceId",
                                "table-id": "hwCatalogue",
                                kebab: ""
                            }, {
                                technology: _withCtx(({ item }) => [
                                    (item.technology === 'LORA')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref($t)(item.technology.toLowerCase())), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.technology), 1))
                                ]),
                                transformationId: _withCtx(({ item }) => [
                                    _createTextVNode(_toDisplayString(transformationFunctions.value.find((tf) => tf.transformationId === item.transformationId)?.label), 1)
                                ]),
                                "kebab-actions": _withCtx(({ item }) => [
                                    _createElementVNode("div", {
                                        class: "dropdown-actions__item d-flex align-items-center",
                                        onClick: ($event) => (showDetail(item))
                                    }, [
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "atom-icon" }, [
                                            _createElementVNode("img", { src: _imports_1 })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref($t)("SHOW_DETAIL")), 1)
                                    ], 8, _hoisted_8),
                                    _createElementVNode("div", {
                                        class: "dropdown-actions__item d-flex align-items-center",
                                        onClick: ($event) => (edit(item))
                                    }, [
                                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "atom-icon" }, [
                                            _createElementVNode("img", { src: _imports_2 })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref($t)("EDIT")), 1)
                                    ], 8, _hoisted_9),
                                    _createElementVNode("div", {
                                        class: "dropdown-actions__item d-flex align-items-center",
                                        onClick: ($event) => (handleDelete(item))
                                    }, [
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "atom-icon" }, [
                                            _createElementVNode("img", { src: _imports_3 })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_unref($t)("DELETE_TF")), 1)
                                    ], 8, _hoisted_10)
                                ]),
                                _: 1
                            }, 8, ["items", "items-total-count"])
                        ]))
                        : (!isTFLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref($t)("nicKZobrazeni")) + ".", 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(Loader)
                            ]))
                ]),
                (openedItem.value)
                    ? (_openBlock(), _createBlock(HwDeviceFormModal, {
                        key: 0,
                        "hw-device": openedItem.value,
                        "transformation-function-options": transformationFunctions.value.filter(tf => tf.type === 'PAYLOAD'),
                        "is-open": isFormModalOpen.value,
                        "read-only": isFormModalReadOnly.value,
                        onClose: _cache[0] || (_cache[0] = ($event) => (isFormModalOpen.value = false)),
                        onChange: loadItems
                    }, null, 8, ["hw-device", "transformation-function-options", "is-open", "read-only"]))
                    : _createCommentVNode("", true),
                (openedItem.value)
                    ? (_openBlock(), _createBlock(DeleteModal, {
                        key: 1,
                        opened: isDeleteOpen.value,
                        items: openedItem.value,
                        text: openedItem.value.model,
                        centered: true,
                        onYes: handleDeleteConfirmed,
                        onClose: _cache[1] || (_cache[1] = ($event) => (isDeleteOpen.value = false))
                    }, null, 8, ["opened", "items", "text"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
